// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"20de87b0","453":"9bab55d1","455":"1d8d824b","977":"87ebf09d"}[chunkId] + ".chunk.js";
};